import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const StyledButtonV2 = styled((props) => <Button {...props} />)({
  paddingTop: 14,
  paddingRight: 45,
  paddingBottom: 14,
  paddingLeft: 30,
  borderRadius: 5,
  color: "#FFFFFF",
  fontWeight: 600,
  // boxShadow: "0px 4px 0px 0px #c55c01",
  // border: "2px solid transparent",
  // "&:hover": {
  //   boxShadow: "0px 4px 0px 0px #c55c01",
  //   border: "2px solid transparent",
  // },
});
